import gql from 'graphql-tag'

export const UPDATE_PHONE_BLOCKED_DATA = gql`
    mutation updatePhoneBlockData($input: PhoneBlockedDataInput!) {
        updatePhoneBlockData(input: $input)
    }
`
